import { Suspense, lazy } from 'react';
import { LoaderErrorBoundary } from './LoaderErrorBoundary';
import { LoaderMessage } from './LoaderMessage';

type LoadResults = {
  default: React.ComponentType<any>;
};

export interface LoaderProps<C> {
  readonly load: React.LazyExoticComponent<React.ComponentType<C>>;
}

export const Loader = <C extends LoadResults>({
  load,
  ...restProps
}: LoaderProps<C> & React.ComponentPropsWithRef<C['default']>) => {
  const LazyComponent = load || lazy(load);

  return (
    <LoaderErrorBoundary>
      <Suspense fallback={<LoaderMessage />}>
        <LazyComponent {...restProps} />
      </Suspense>
    </LoaderErrorBoundary>
  );
};
